import { render, staticRenderFns } from "./AddTextBlockModal.vue?vue&type=template&id=3d9412e4&lang=pug&"
import script from "./AddTextBlockModal.vue?vue&type=script&lang=js&"
export * from "./AddTextBlockModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTextBlockModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports